import { useEffect, useState } from 'react';

// Subscribe to the `cgTableFilterReady` event that CgSearchFilter
// broadcasts whenever its filter form state changes. Returns the
// presetData payload (saved presets list + load/save/delete callbacks)
// so siblings of the table (e.g. smart-segments rows above the table)
// can drive the same preset architecture as the chip-toolbar.
//
// The hook is event-based because the segments component sits OUTSIDE
// the CgTable subtree, so the direct onFiltersReady callback wired
// inside CgTable doesn't reach it.
//
// Caller can pass a tableId to filter events by table — multiple tables
// on the same page would otherwise cross-talk. If omitted, all events
// are accepted (one-table pages don't need to bother).
const usePresetSubscription = (tableId) => {
  const [presetData, setPresetData] = useState(null);

  useEffect(() => {
    const onReady = (event) => {
      if (tableId && event.detail?.presetData?.tableId !== tableId) return;
      if (event.detail?.presetData) setPresetData(event.detail.presetData);
    };
    window.addEventListener('cgTableFilterReady', onReady);
    return () => window.removeEventListener('cgTableFilterReady', onReady);
  }, [tableId]);

  return {
    savedPresets: presetData?.presets ?? [],
    matchingPresetId: presetData?.matchingPreset?.id ?? null,
    canSaveCurrentView: Boolean(presetData?.shouldShowSaveButton),
    onSavePreset: presetData?.onSavePreset,
    handleLoadPreset: presetData?.handleLoadPreset,
    handleDeletePreset: presetData?.handleDeletePreset,
  };
};

export default usePresetSubscription;
